<div class="custom-app-body">
  <main class="custom-main">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-10 mx-auto">
          <div class="card-group custom-login-wrapper">
            
            <!-- Login -->
            <div class="card p-4">
              <div class="card-body">
                <form [formGroup]="login" (ngSubmit)="onSubmit()">
                  <h1>Login</h1>
                  <p class="text-muted">Inicia sesión con tu cuenta.</p>

                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-user"></i></span>
                    </div>
                    <input type="text" class="form-control" formControlName="email" placeholder="Username" required>
                  </div>

                  <div class="input-group mb-4">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input [type]="showPassword ? 'text' : 'password'" class="form-control" formControlName="password" placeholder="Password" required>
                    <button type="button" class="btn btn-outline-secondary" (click)="togglePassword()">
                      <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                    </button>
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <button type="submit" class="btn btn-primary px-4">Login</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <!-- NetRide info -->
            <div class="card custom-info-card text-white d-none d-lg-flex">
              <div class="card-body text-center d-flex flex-column justify-content-center align-items-center">
                 <img src="assets/img/brand/NetRideEnterprise_IconoBlanco.svg" alt="NetRide Logo" class="netride-logo">
                <h2 class="info-title">NetRide</h2>
                <p class="info-text">Tecnología que OPTIMIZA EL IMPACTO publicitario en trayectos urbanos.</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </main>
</div>
